import { useEffect, useState } from "react";
import "./Dashboard.css";

import avatar from "./assets/schoolboy.png";
import robot from "./assets/robort.png";

// optional images (fallback if you want later)
import math from "./assets/webdevelopment.png";
import english from "./assets/dataanylatics.png";
import science from "./assets/datascience.png";
import cs from "./assets/python.png";

export default function Dashboard() {

  const [data, setData] = useState({
    name: "",
    courses: []
  });

  useEffect(() => {
    fetch("https://script.google.com/macros/s/AKfycby6zHsfCNMrrInucwlBzGvWXKiMQwaHavfnnwAiCl0S7NF0ZaR4JvjGYWPG3oPO9B6e/exec") // 🔥 PUT YOUR URL
      .then(res => res.json())
      .then(res => setData(res))
      .catch(() => console.log("Error fetching data"));
  }, []);

  return (
    <div className="dash-container">

      {/* SIDEBAR */}
      <div className="dash-sidebar">
        <h2 className="logo">BCI</h2>

        <ul>
          <li className="active">🏠 Dashboard</li>
          <li>📘 My Courses</li>
          <li>📝 Quizzes</li>
          <li>🏆 Certificates</li>
        </ul>
      </div>

      {/* MAIN */}
      <div className="dash-main">

        {/* TOP BAR */}
        <div className="dash-top">
          <h2>Dashboard</h2>
          <img src={avatar} alt="profile" className="profile" />
        </div>

        {/* WELCOME */}
        <div className="welcome-card">
          <img src={avatar} alt="student" />
          <div>
            <h3>Welcome back {data.name || "Student"}!</h3>
            <p>Let’s continue your progress 🚀</p>
          </div>
        </div>

        {/* CONTENT */}
        <div className="dash-content">

          {/* COURSES */}
          <div className="courses">
            <h3>My Courses</h3>

            <div className="course-grid">

              {data.courses.length === 0 ? (
                <p>Loading courses...</p>
              ) : (
                data.courses.map((course, i) => (
                  <Course
                    key={i}
                    title={course.title}
                    progress={course.progress}
                  />
                ))
              )}

            </div>
          </div>

          {/* RIGHT PANEL (UNCHANGED UI) */}
          <div className="side-panels">

            <div className="streak">
              🏆 Learning Streak <br />
              <strong>Day {data.streak}</strong>
            </div>

            <div className="goals">
              <h4>Today's Goals</h4>
              <p>✅ Watch 2 lessons</p>
              <p>✅ Score 80% on quiz</p>
            </div>

            <div className="calendar">
              <h4>Calendar</h4>
              <img src={robot} alt="bot" />
            </div>

          </div>

        </div>
      </div>
    </div>
  );
}

/* COURSE CARD */
function Course({ title, progress }) {
  return (
    <div className="course-card">
      <h4>{title}</h4>

      <div className="bar">
        <div style={{ width: progress }}></div>
      </div>

      <span>{progress}</span>

      <button>Continue</button>
    </div>
  );
}